import { AfterViewInit, Component, OnInit } from '@angular/core';
import { animate, circOut } from 'popmotion';
import { GlobalUtilsService } from 'src/app/global-utils.service';

@Component({
  selector: 'app-big-title',
  templateUrl: './big-title.component.html',
  styleUrls: ['./big-title.component.scss'],
})
export class BigTitleComponent implements OnInit, AfterViewInit {
  instanciasAnimacao = [];

  constructor(public globalUtilsService: GlobalUtilsService) {}

  ngOnInit() {}

  ngAfterViewInit(): void {
    const p = ['.first-paragraph', '.second-paragraph', '.third-paragraph', '.fourth-paragraph'];
    let i = 0;

    i = this.animateNewComponent(p, i);

    setInterval(() => {
      i = this.animateNewComponent(p, i);
    }, 4500);
  }

  private animateNewComponent(p: string[], i: number) {
    const chave = p[i];
    document.querySelectorAll<HTMLDivElement>('.paragraph').forEach((v, k) => {
      v.style.display = 'none';
    });
    document.querySelector<HTMLDivElement>(chave).style.display = 'block';
    i = (i + 1) % p.length;

    this.instanciasAnimacao.forEach((v) => v.stop());
    this.instanciasAnimacao = [];

    document
      .querySelectorAll<HTMLDivElement>(`${chave} .char`)
      .forEach((e, i) => {
        let a = animate({
          from: 50,
          to: 0,
          ease: circOut,
          elapsed: -i * 10,
          duration: 300,
          onUpdate: (value) => {
            e.style.transform = `translateY(${value}px)`;
          },
        });

        let b = animate({
          from: 0,
          to: 1,
          elapsed: -i * 14,
          ease: circOut,
          duration: 300,
          onUpdate: (value) => {
            e.style.opacity = `${value}`;
          },
        });

        this.instanciasAnimacao.push(a, b);
      });

    let c = animate({
      to: [0, 1, 0],
      duration: 800,
      elapsed: 5300,
      repeat: 'Infinity' as any,
      onUpdate: (val) => {
        document.querySelector<HTMLDivElement>(
          `${chave} .underline`
        ).style.opacity = `${val}`;
      },
    });

    this.instanciasAnimacao.push(c);

    return i;
  }

  private _updateAnimation() {}
}
